import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { TranscriptionDialogContext } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import SelectionComponent from './SelectionComponent';

export interface SoloComponentProps {
  setCurrentStep: (soloSelected: boolean) => void;
}

const SoloComponent: React.FC<SoloComponentProps> = ({ setCurrentStep }) => {
  const { setSettings } = React.useContext(TranscriptionDialogContext);
  const { t } = useTranslation();
  const handleClick = (isSolo: boolean) => {
    if (isSolo) {
      setSettings({ solo: true });
      setCurrentStep(isSolo);
    } else {
      setCurrentStep(isSolo);
    }
  };

  const answers = [
    { title: t('home.input.dialog.soloRecording.solo'), key: true },
    { title: t('home.input.dialog.soloRecording.multiple'), key: false },
    { title: t('home.input.dialog.unknown'), key: null },
  ];

  return <SelectionComponent answers={answers} handleClick={handleClick} id="solo" />;
};

export default SoloComponent;
